import { QuestionType } from '@empathy/survey/base';

import { QuestionFormAIChat } from './question-form-ai-chat.model';
import { QuestionFormCarouselMultiChoice } from './question-form-carousel-multi-choice.model';
import { QuestionFormCarouselRating } from './question-form-carousel-rating.model';
import { QuestionFormCarousel } from './question-form-carousel.model';
import { QuestionFormDropdown } from './question-form-dropdown.model';
import { QuestionFormEssay } from './question-form-essay.model';
import { QuestionFormFileUpload } from './question-form-file-upload.model';
import { QuestionFormHeatmap } from './question-form-heatmap.model';
import { QuestionFormHiddenChoice } from './question-form-hidden-choice.model';
import { QuestionFormInfo } from './question-form-info.model';
import { QuestionFormInput } from './question-form-input.model';
import { QuestionFormMultiChoice } from './question-form-multi-choice.model';
import { QuestionFormNPS } from './question-form-nps.model';
import { QuestionFormRanking } from './question-form-ranking.model';
import { QuestionFormRating } from './question-form-rating.model';
import { QuestionFormSingleChoice } from './question-form-single-choice.model';
import { QuestionFormTerminate } from './question-form-terminate.model';
import { QuestionForm } from './question-form.model';
import { QuestionFormRankSort } from './question-form-rank-sort.model';

export const QuestionFormInstanceByType = (type: QuestionType): QuestionForm => {
  switch (type) {
    case QuestionType.Carousel:
      return new QuestionFormCarousel();
    case QuestionType.CarouselMultiChoice:
      return new QuestionFormCarouselMultiChoice();
    case QuestionType.CarouselRating:
      return new QuestionFormCarouselRating();
    case QuestionType.Dropdown:
      return new QuestionFormDropdown();
    case QuestionType.Essay:
      return new QuestionFormEssay();
    case QuestionType.Heatmap:
      return new QuestionFormHeatmap();
    case QuestionType.Input:
      return new QuestionFormInput();
    case QuestionType.MultiChoice:
      return new QuestionFormMultiChoice();
    case QuestionType.Rating:
      return new QuestionFormRating();
    case QuestionType.SingleChoice:
      return new QuestionFormSingleChoice();
    case QuestionType.Terminate:
      return new QuestionFormTerminate();
    case QuestionType.InfoPage:
      return new QuestionFormInfo();
    case QuestionType.FileUpload:
      return new QuestionFormFileUpload();
    case QuestionType.HiddenChoice:
      return new QuestionFormHiddenChoice();
    case QuestionType.AIChat:
      return new QuestionFormAIChat();
    case QuestionType.NPS:
      return new QuestionFormNPS();
    case QuestionType.Ranking:
      return new QuestionFormRanking();
    case QuestionType.RankSort:
      return new QuestionFormRankSort();
  }
};
